import React, { Dispatch, SetStateAction } from 'react';
import { CountryConfig } from '../widget/widget-init';

export const CountryStateContext = React.createContext<
  | {
      country: CountryConfig;
      updateCountry: Dispatch<SetStateAction<CountryConfig>>;
    }
  | undefined
>(undefined);

export function useCountryState() {
  const countryState = React.useContext(CountryStateContext);
  if (countryState !== undefined) {
    return countryState;
  }
  throw 'CountryStateContext is not yet defined, you are probably using it in a wrong place';
}
